import React from 'react';
import { RiArrowLeftLine } from 'react-icons/ri';

import { Container } from './styles';

interface Props {
  color: 'primary' | 'white';
}

const ArrowBack: React.FC<Props> = ({ color }) => {
  return (
    <Container to="/" title="Go back" color={color} data-cy="arrow-back">
      <RiArrowLeftLine />
    </Container>
  );
};

export default ArrowBack;
